// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"27xXA":[function(require,module,exports) {
require("922191eb72829a0a").register(require("7f0f657183bdd3e3").getBundleURL("sif1r"), JSON.parse('["sif1r","index.9ab22280.js","av0At","background.7652ee9a.svg","3X7Iy","paratime-selector-glow.428132fa.svg","b8uZd","paratime-selector-globe.0ad455d3.svg","i8sRh","paratime-selector-glow-testnet.fa73b1cf.svg","l68O2","paratime-selector-globe-testnet.52b04c00.svg","fBRN3","background-social.9d56e730.png","4kXRk","telegram.0ae1e870.svg","b1LUQ","twitter.25c9a221.svg","1mGcr","discord.e271280c.svg","4IkAE","youtube.73dfde61.svg","l1vEY","reddit.b42bab17.svg","faK4e","euroe.91b1e510.png","115Vm","background-empty-state.a5413910.svg","7zYpg","editor.main.dcf87b46.js","jtr7c","abap.e08ecd23.js","2t2o2","apex.9ea4266a.js","dh2Hg","azcli.4d75be0d.js","kgNPm","bat.f596a5de.js","efNHW","bicep.cf3ecadd.js","ltvAN","cameligo.c60b5c57.js","jXXwU","clojure.be63357c.js","6PdeO","coffee.9ded86d4.js","bpZDd","cpp.3b61fed8.js","dVL5F","csharp.40d95a22.js","e9eSK","csp.09557d14.js","gpU41","css.1d7353bd.js","a2mxc","cypher.f83e4493.js","ekVrR","dart.e4b2324a.js","8RSTg","dockerfile.6f875545.js","gFXBk","ecl.f395a00d.js","imIQp","elixir.87474f5d.js","kfLmT","flow9.3885cb76.js","1On7z","fsharp.9c156047.js","kafUa","freemarker2.72ce2938.js","lbG0z","go.a058885f.js","3sKff","graphql.1980ffdc.js","3LTdm","handlebars.2a0883d9.js","iEv07","hcl.6bb8c315.js","l87e7","html.c1ca0607.js","7fJzM","ini.3e5da4bb.js","i9EvH","java.f023f6d6.js","upRHL","javascript.b7123993.js","g7nxB","typescript.0828d34d.js","lD2Kc","julia.b9de8a5e.js","jZhdF","kotlin.53eafcca.js","j1TGy","less.943a3706.js","e81BP","lexon.a0fd7e41.js","7hn27","lua.11683278.js","aSb1s","liquid.a07e23dc.js","2MuK5","m3.7d6e3110.js","2sRPH","markdown.9d1d89a0.js","esv6y","mdx.ecd87249.js","1iHz5","mips.a891f69d.js","75AjF","msdax.cfd453af.js","hcZJA","mysql.c28dc9d2.js","a7IXa","objective-c.18f81721.js","5ZiNr","pascal.f44831c1.js","i5B22","pascaligo.775966c1.js","eBrdm","perl.e3705374.js","dwOVa","pgsql.34e3c2c7.js","e5uPT","php.4f2c7081.js","3Xucr","pla.1f6ea087.js","laVGG","postiats.538c8797.js","adik2","powerquery.75e20323.js","dQmfk","powershell.73561666.js","5hIs6","protobuf.1ceaea80.js","2bQFj","pug.7d2822bf.js","4iTMT","python.e11fe0d5.js","k94kx","qsharp.3b96e9be.js","h7zrs","r.4bd7ae36.js","aOlAN","razor.3b3af005.js","7y9eZ","redis.5f38705c.js","1FJcn","redshift.4f399a3d.js","7ox89","restructuredtext.5a9b13b5.js","4erol","ruby.a1cd3348.js","ex7gL","rust.8426d38e.js","6MTwQ","sb.36e3cada.js","7d6e8","scala.84cb7c85.js","1Stm6","scheme.a7d96094.js","bZYTr","scss.963e4bbe.js","7821L","shell.46b102ca.js","dS9TL","solidity.316cf8e8.js","iYueM","sophia.b1f7ba13.js","1BNc1","sparql.10ae346e.js","l8cHg","sql.13c02df8.js","eimI0","st.ebd4efe7.js","jtxAP","swift.6f9edb96.js","1If42","systemverilog.94fb033c.js","8kdKK","tcl.274b9326.js","1a3kD","twig.8ae624f7.js","3REbq","typespec.68907f57.js","aZf5o","vb.3b88041a.js","8yk23","wgsl.5e0cf44f.js","bD2FF","xml.cdf767b6.js","4RGwG","yaml.660c7721.js","lB5HG","cssMode.fb8ab920.js","a3gBq","htmlMode.0265b6c2.js","iheJE","jsonMode.a37b1d54.js","3fw0q","tsMode.9eca10ec.js","fkqXa","editor.main.85052f05.css","gkSMd","codicon.3e079ac2.ttf","1nZ7Y","dist.bc4cea1a.js","lhaVj","editor.worker.45c48d3f.js","81TZv","index.1d8e5fad.css"]'));

},{"922191eb72829a0a":"bJTvR","7f0f657183bdd3e3":"ccgWN"}],"bJTvR":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"ccgWN":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["27xXA"], null, "parcelRequire27e2")

//# sourceMappingURL=index.runtime.e09d4cba.js.map
